import { Suspense } from 'react';
import { Outlet, useLocation, useMatches } from 'react-router-dom';
import { ErrorBoundary } from 'components/errors/error-boundary';

import { DashboardLayout } from 'components/layouts/dashboard-layout';
import { ClaimReviewFallbackControls } from 'components/layouts/dashboard-layout/claim-review-layout';
import { Spinner } from 'components/ui/spinner';
import type { DashboardNavigation } from 'components/layouts/dashboard-layout/types';

type AppRootProps = {
    navigation: DashboardNavigation;
};

export const AppRoot = ({ navigation }: AppRootProps) => {
    const location = useLocation();
    const matches = useMatches();
    const claimReview = matches.some(
        (match) =>
            (match.handle as { claimReview?: boolean } | undefined)
                ?.claimReview === true,
    );
    return (
        <DashboardLayout navigation={navigation} claimReview={claimReview}>
            <Suspense
                fallback={
                    <>
                        <ClaimReviewFallbackControls />
                        <div className="flex size-full items-center justify-center">
                            <Spinner size="xl" />
                        </div>
                    </>
                }
            >
                <ErrorBoundary key={location.pathname}>
                    <Outlet />
                </ErrorBoundary>
            </Suspense>
        </DashboardLayout>
    );
};
